import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.getAttribute("url"), { frame: "_top", action: "advance" })
}
